module.exports = __webpack_public_path__ + "static/media/sweat.1455f6b5.png";